export default {
    title: "<strong>Mein erster Punkt</strong> in dieser Liste",
    jumpTo: { type: 'next', href: null, id: null, slug: null },
    iconSet: "heroicon",
    iconType: "outline",
    iconName: "FilterIcon",
    style: { backgroundColor: null, color: null, }
}
